import { render, staticRenderFns } from "./DataEditionSelectedIndividuals.vue?vue&type=template&id=483e79dc&"
import script from "./DataEditionSelectedIndividuals.vue?vue&type=script&lang=js&"
export * from "./DataEditionSelectedIndividuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports